/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoFromJSONTyped,
    TaskInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface SolrReindexEndpointResponse
 */
export interface SolrReindexEndpointResponse {
    /**
     * 
     * @type {Array<TaskInfo>}
     * @memberof SolrReindexEndpointResponse
     */
    tasks: Array<TaskInfo>;
}

export function SolrReindexEndpointResponseFromJSON(json: any): SolrReindexEndpointResponse {
    return SolrReindexEndpointResponseFromJSONTyped(json, false);
}

export function SolrReindexEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrReindexEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tasks': ((json['tasks'] as Array<any>).map(TaskInfoFromJSON)),
    };
}

export function SolrReindexEndpointResponseToJSON(value?: SolrReindexEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tasks': ((value.tasks as Array<any>).map(TaskInfoToJSON)),
    };
}


